import { format } from 'date-fns';

export const formatDate = (value: string | null | undefined): string => {
  if (value == null) return '';
  try {
    return format(new Date(value), 'MM/dd/yyyy');
  } catch {
    return value;
  }
};
